<div class="widget-container">
  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p class="loading-text">Cargando plan de cuotas...</p>
  </div>

  <div *ngIf="!loading && error" class="error-container">
    <p class="error-text">{{ error }}</p>
    <button *ngIf="errorType !== 'auth'" class="btn-retry" (click)="retry()">Reintentar</button>
  </div>

  <div *ngIf="!loading && !error">
    <div class="summary-cards">
      <div class="summary-card card-total">
        <div class="card-icon"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg></div>
        <div class="card-content"><span class="card-value">{{ summary.total }}</span><span class="card-label">Total Cuotas</span></div>
      </div>
      <div class="summary-card card-paid">
        <div class="card-icon icon-green"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg></div>
        <div class="card-content"><span class="card-value">{{ summary.paid }}</span><span class="card-label">Pagadas</span></div>
      </div>
      <div class="summary-card card-overdue">
        <div class="card-icon icon-red"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></div>
        <div class="card-content"><span class="card-value">{{ summary.overdue }}</span><span class="card-label">Vencidas</span></div>
      </div>
      <div class="summary-card card-debt">
        <div class="card-icon icon-orange"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg></div>
        <div class="card-content">
          <span class="card-value">{{ formatCurrency(summary.totalDebt) }}</span>
          <span class="card-label">Deuda</span>
          <span class="card-sub" *ngIf="summary.totalPenalties > 0">+ {{ formatCurrency(summary.totalPenalties) }} penalidades</span>
        </div>
      </div>
    </div>

    <div class="table-section">
      <div class="table-header">
        <h3 class="table-title">Plan de Cuotas</h3>
        <span class="table-subtitle">Cronograma de cuotas con penalidades aplicadas por mora</span>
      </div>

      <div *ngIf="installments.length === 0" class="empty-state"><p>No hay cuotas registradas</p></div>

      <div *ngIf="installments.length > 0" class="table-wrapper">
        <table class="installments-table">
          <thead>
            <tr>
              <th>Cuota</th>
              <th>Fecha Vencimiento</th>
              <th>Monto Cuota</th>
              <th>Penalidad</th>
              <th>Total Adeudado</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let inst of installments" [ngClass]="getStatusClass(inst.status)">
              <td>
                <span class="order-num">{{ inst.order }}</span>
                <span class="credit-id">{{ inst.invoice?.identifier }}</span>
              </td>
              <td>{{ formatDate(inst.scheduledPaymentDate) }}</td>
              <td>{{ formatCurrency(inst.amount) }}</td>
              <td>
                <span *ngIf="inst.penalties > 0" class="penalty-val">{{ formatCurrency(inst.penalties) }}</span>
                <span *ngIf="inst.penalties === 0">—</span>
              </td>
              <td class="cell-bold">{{ formatCurrency(inst.dueBalance + inst.penalties) }}</td>
              <td>
                <span class="status-badge" [ngClass]="getStatusClass(inst.status)">
                  {{ getStatusLabel(inst.status) }}
                  <span *ngIf="inst.daysOverdue > 0" class="days-badge">{{ inst.daysOverdue }}d</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
